import type { EQIAdvisor } from '@/modules/Customer/interface/Advisor';
import type { FC } from 'react';
import { Flex } from '@eqi-investimentos/react';
import { CardMyAdvisor } from '@/components/molecules/CardMyAdvisor';
import { IfRender } from '@/utils/jsx';
export const SectionMyConsultancy: FC<SectionMyConsultancyProps> = ({
  advisorData,
  isEqiDigital
}) => <IfRender condition={!!advisorData?.advisorName} data-sentry-element="IfRender" data-sentry-component="SectionMyConsultancy" data-sentry-source-file="SectionMyConsultancy.tsx">
    <Flex justifyContent="center" alignItems="center" w="full" px="2xl" data-sentry-element="Flex" data-sentry-source-file="SectionMyConsultancy.tsx">
      <CardMyAdvisor hasAdvisor={!isEqiDigital} variant="mobile" data-sentry-element="CardMyAdvisor" data-sentry-source-file="SectionMyConsultancy.tsx" />
    </Flex>
  </IfRender>;
type SectionMyConsultancyProps = {
  advisorData: Partial<EQIAdvisor>;
  isEqiDigital?: boolean;
};